import React, { useState } from "react";
import SubHeader from "../../layout/components/SubHeader";
import { KTIcon } from "../../helpers";
import { KTSVG } from "../../helpers/KTSVG";
import { Tooltip } from "react-tooltip";
import clsx from "clsx";
function ArticlesHeader({
  handleSortChange,
  handleSearchArticles,
  subHeadingText,
  searchTerm,
  updateSearchTerm,
  handleClearSearchTerm,
}) {
  //const [searchTerm, setSearchTerm] = useState("");
  const [sortStatus, setSortStatus] = useState("unsorted");

  const handleSearchChange = (event) => {
    const value = event.target.value;
    //setSearchTerm(value);
    updateSearchTerm(value);
  };
  const handleSearch = () => {
    handleSearchArticles(searchTerm);
  };
  const handleAscendingClick = () => {
    handleSortChange("title", "asc");
  };
  const handleDescendingClick = () => {
    handleSortChange("title", "desc");
  };
  
  const handleLatestClick = () => {
    handleSortChange("lastModified", "asc");
  };
  const handleOldestClick = () => {
    handleSortChange("lastModified", "desc");
  };
  return (
    <>
      <SubHeader title="Articles" description={subHeadingText}>
        {/* Search Bar & Upload Button */}
        <div className="d-flex flex-row justify-content-end align-items-center mt-3">
          <div className="d-flex align-items-center position-relative me-4 mb-2">
            <KTIcon
              iconName="magnifier"
              className="fs-3 position-absolute ms-3"
            />
            <input
              type="text"
              placeholder="Search Articles"
              className="form-control form-control-sm me-2 form-control-solid w-150px ps-10"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {searchTerm &&<>
            <button
              className="btn btn-sm btn-light-info"
              onClick={handleSearch}
            >
              Search
            </button>
            <button 
            className="btn btn-sm btn-light-warning ms-2"
             onClick={handleClearSearchTerm}>
              Clear
            </button>
            </>}
          </div>
          <button
            data-tooltip-id="tt_options"
            data-tooltip-place="bottom-start"
            className="btn btn-outline btn-sm btn-icon-info ms-3 mb-2"
          >
            <KTSVG
              path="media/icons/duotune/general/gen053.svg"
              className="svg-icon-1 "
            />
          </button>
          <Tooltip
            id="tt_options"
            clickable
            className="bg-secondary"
            style={{ zIndex: "107" }}
          >
            <div className="d-flex flex-column">
              <span className="text-gray-800">Sort by name</span>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "ascending",
                })}
                onClick={handleAscendingClick}
              >
                <i className="bi bi-sort-alpha-down fs-4"> </i> Ascending
              </button>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "descending",
                })}
                onClick={handleDescendingClick}
              >
                <i className="bi bi-sort-alpha-up fs-4"> </i> Descending
              </button>
              <span className="text-gray-800">Sort by date</span>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "latest",
                })}
                onClick={handleLatestClick}
              >
                <i className="bi bi-arrow-down fs-4"> </i> Latest
              </button>
              <button
                className={clsx("btn", "btn-sm", "mb-2", "btn-secondary", {
                  active: sortStatus === "oldest",
                })}
                onClick={handleOldestClick}
              >
                <i className="bi bi-arrow-up fs-4"> </i> Oldest
              </button>
            </div>
          </Tooltip>
        </div>
      </SubHeader>
    </>
  );
}

export default ArticlesHeader;
